/*
 * Copyright (c) Nexign, JSC, 2020-2025.
 */
/**
 * The types for the widget Search Accounts
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.3.0
 */

export enum EWidgetSearchAccountsField {
    balance = 'balance',
    number = 'number',
    region = 'region',
    subsCount = 'subsCount',
    inn = 'inn',
    name = 'name',
}

export enum EWidgetSearchAccountsValidationCodes {
    SYNTAX_INCORRECT = 'query.syntax.incorrect',
}

export interface IWidgetSearchAccountsItem {
    [EWidgetSearchAccountsField.balance]: string;
    [EWidgetSearchAccountsField.number]: string;
    [EWidgetSearchAccountsField.region]: string;
    [EWidgetSearchAccountsField.subsCount]: string;
    [EWidgetSearchAccountsField.inn]?: string | null;
    [EWidgetSearchAccountsField.name]?: string | null;
    id: number;
}

export interface IWidgetSearchAccountsResponse {
    accounts: IWidgetSearchAccountsItemResponse[];
}

export interface IWidgetSearchAccountsItemResponse {
    [EWidgetSearchAccountsField.balance]: number;
    [EWidgetSearchAccountsField.number]: string;
    [EWidgetSearchAccountsField.region]: string;
    [EWidgetSearchAccountsField.subsCount]: number;
    [EWidgetSearchAccountsField.inn]?: string | null;
    [EWidgetSearchAccountsField.name]?: string | null;
    id: number;
}
